module.exports = __webpack_public_path__ + "img/down12.03036562.png";